var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.015 0C5.40676 0 0 5.40676 0 12.015C0 18.6233 5.40676 24.03 12.015 24.03C15.3191 24.03 18.383 22.7384 20.5457 20.5457L18.383 18.383C16.761 20.005 14.5081 21.0263 11.985 21.0263C6.99875 21.0263 2.97372 17.0013 2.97372 12.015C2.97372 7.02879 6.99875 3.00375 11.985 3.00375C14.4781 3.00375 16.6408 4.08511 18.2628 5.73717L14.9887 9.01126H24V0L20.4255 3.57447C18.2628 1.41176 15.2891 0 11.985 0H12.015Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/Reload.df11d832c434e8469e582847772db327.svg";
export { ForwardRef as ReactComponent };